import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .optional-toggles {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .section-divider {
    border: none;
    border-top: 1px solid var(--sds-color-border-default-default);
    margin: 0;
    margin-left: var(--section-divider-margin-left, 0);
    margin-right: var(--section-divider-margin-right, 0);
    padding: 0;
  }

  .toggle-field {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .toggle-field wow-switch {
    --wow-switch-border-top: none;
  }

  .loading-links,
  .no-links {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    padding: 8px;
    text-align: center;
  }

  .link-selects {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .link-select-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .link-select-row wow-select {
    flex: 1;
  }

  .link-select-row wow-button {
    margin-top: 16px;
  }

  .add-extra-button {
    background: none;
    border: none;
    cursor: pointer;
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-brand-default);
    padding: 4px 0;
    text-align: left;
    align-self: flex-start;
    text-decoration: underline;
  }

  .add-extra-button:hover {
    text-decoration: none;
  }
`;
